/*! License details at fancyapps.com/license */
import { addClass as t } from "../utils/addClass.js";
import { isPlainObject as e } from "../utils/isPlainObject.js";
import { stringToHtml as n } from "../utils/strToHtml.js";
import { toggleClass as o } from "../utils/toggleClass.js";
var r = {
    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg>',
    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg>'
  },
  s = function s() {
    var s, i, l;
    function a() {
      var t = null == s ? void 0 : s.getOptions().Arrows;
      return e(t) ? Object.assign(Object.assign({}, r), t) : r;
    }
    function u(e) {
      if (!s) return;
      var o = "<button data-carousel-go-".concat(e, " tabindex=\"0\" class=\"f-button is-arrow is-").concat(e, "\" title=\"{{").concat(e.toUpperCase(), "}}\">") + a()["".concat(e, "Tpl")] + "</button",
        r = n(s.localize(o)) || void 0;
      return r && t(r, a()["".concat(e, "Class")]), r;
    }
    function g() {
      var t;
      null == i || i.remove(), i = void 0, null == l || l.remove(), l = void 0, null === (t = null == s ? void 0 : s.getContainer()) || void 0 === t || t.classList.remove("has-arrows");
    }
    function c() {
      s && !1 !== s.getOptions().Arrows && s.getPages().length > 1 ? (!function () {
        if (!s) return;
        var t = s.getViewport();
        t && (i || (i = u("prev"), i && t.insertAdjacentElement("beforebegin", i)), l || (l = u("next"), l && t.insertAdjacentElement("afterend", l)), o(s.getContainer(), "has-arrows", !(!i && !l)));
      }(), s && (null == i || i.toggleAttribute("aria-disabled", !s.canGoPrev()), null == l || l.toggleAttribute("aria-disabled", !s.canGoNext()))) : g();
    }
    return {
      init: function init(t) {
        s = t.on(["change", "refresh"], c);
      },
      destroy: function destroy() {
        g(), null == s || s.off(["change", "refresh"], c), s = void 0;
      }
    };
  };
export { s as Arrows };